import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { useInstallPrompt } from "@/hooks/useInstallPrompt";

// Banner automático que aparece por engajamento. Botão sob-demanda vive em InstallAppButton.
export default function InstallPWA() {
  const { available, isIOS, hasNativePrompt, install } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem("bbh_pwa_dismissed") === "1") setDismissed(true);
    } catch { /* ignore */ }
  }, []);

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem("bbh_pwa_dismissed", "1"); } catch { /* ignore */ }
  };

  const clickInstall = async () => {
    const outcome = await install();
    if (outcome === "accepted") dismiss();
  };

  if (dismissed || !available) return null;

  if (hasNativePrompt) {
    return (
      <div
        className="fixed bottom-20 md:bottom-6 right-4 z-50 bbh-card p-3 pr-2 flex items-center gap-3 shadow-lg"
        data-testid="pwa-install-banner"
      >
        <div className="w-10 h-10 rounded-md bg-[#14243D] text-white flex items-center justify-center">
          <Download className="w-5 h-5" />
        </div>
        <div className="pr-2">
          <div className="text-sm font-semibold">Instalar BBH Orçamentos</div>
          <div className="text-xs text-zinc-500">Acesse rápido pelo ícone no seu aparelho.</div>
        </div>
        <button
          onClick={clickInstall}
          data-testid="pwa-install-btn"
          className="px-3 py-2 rounded-md bbh-btn-primary text-xs font-semibold"
        >
          Instalar
        </button>
        <button onClick={dismiss} className="p-1 text-zinc-400 hover:text-zinc-700" aria-label="Fechar">
          <X className="w-4 h-4" />
        </button>
      </div>
    );
  }

  if (isIOS) {
    return (
      <div
        className="fixed bottom-20 md:bottom-6 right-4 left-4 md:left-auto md:max-w-sm z-50 bbh-card p-4 shadow-lg"
        data-testid="pwa-ios-banner"
      >
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-md bg-[#14243D] text-white flex items-center justify-center shrink-0">
            <Download className="w-5 h-5" />
          </div>
          <div className="flex-1 text-sm">
            <div className="font-semibold mb-1">Instalar BBH Orçamentos</div>
            <div className="text-xs text-zinc-600">
              No Safari, toque em <b>Compartilhar</b> e escolha <b>Adicionar à Tela de Início</b>.
            </div>
          </div>
          <button onClick={dismiss} className="p-1 text-zinc-400 hover:text-zinc-700" aria-label="Fechar">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    );
  }

  return null;
}
